module.exports = {
  remote: {
    require() {},
  },
};
